import { Component } from '@angular/core';

@Component({
  selector: 'app-version-label',
  templateUrl: './version-label.component.html',
  styleUrls: ['./version-label.component.scss'],
	standalone: true
})
export class VersionLabelComponent {

}
